export default "__VITE_ASSET__769b0ff4__"